import React, { useMemo } from "react";
import Animated, { useAnimatedStyle, withTiming } from "react-native-reanimated";
import { Icon } from "@lookiero/sty-psp-ui";
import { style as animatedCheckedStyle } from "./AnimatedChecked.style";
const AnimatedChecked = ({ checked, icon = "tick", style: customStyle }) => {
    const style = useMemo(() => animatedCheckedStyle(), []);
    const inputOptionViewAnimatedStyle = useAnimatedStyle(() => ({
        opacity: withTiming(checked ? 1 : 0),
    }), [checked]);
    const overlayAnimatedStyle = useAnimatedStyle(() => ({
        opacity: withTiming(checked ? 1 : 0),
    }), [checked]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Animated.View, { style: [style.overlay, overlayAnimatedStyle, customStyle?.container], testID: "animated-checked-overlay" }),
        React.createElement(Animated.View, { style: [style.inputOptionView, inputOptionViewAnimatedStyle, customStyle?.iconContainer], testID: "animated-checked" },
            React.createElement(Icon, { name: icon, style: [style.icon, customStyle?.icon] }))));
};
export { AnimatedChecked };
